import { Platform as ReactNativePlatform } from 'react-native';

const Platform = {
  OS: ReactNativePlatform.OS,
};

export default Platform;
